// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"0":"d0545b94","4":"5719764d","279":"4e238942","303":"a3adbcab","326":"5719764d","472":"be05f7c2","537":"5c7b5482","628":"5719764d","724":"5719764d","772":"28f3bf82","795":"97872b96"}[chunkId] + ".chunk.css";
};